import { connect } from 'react-redux';
import SsoRoleList from './SsoRoleList';

const mapStateToProps = (state) => ({
  ajaxStatus: state.ajax,
  localisation: state.localisation,
  appLoading: state.meta.appLoading,
});

export default connect(mapStateToProps)(SsoRoleList);
